import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from "reactstrap";
import { URL } from '../../api';
import Banner from '../../components/general/Banner';
import Celikler from '../../components/general/Celikler';
import { fetchPageGetSlug } from '../../redux/slices/pageGetSlugSlice';
import { fetchSeoGet } from '../../redux/slices/seoGetSlice';
import { LineCount } from '../../utilities/line-count';

const Solution = () => {
  const page = useSelector((state) => state.pageGetSlug.data);
  const seo = useSelector((state) => state.seoGet.data);
  const [loading, setLoading] = useState(false);
  const lang = useSelector((state) => state.lang.lang);
  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true)
    await dispatch(fetchPageGetSlug({ slug: "istasyonlar" }));
    await dispatch(fetchSeoGet({ slug: "istasyonlar" }));
    setLoading(false)
  }

  useEffect(() => { getData() }, [])

  return (
    !loading ? <Celikler>
      {seo && seo.title && seo.description && (
        <Helmet>
          <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
          <meta name="description" content={seo.description?.[lang] || ""} />
          <meta name="keywords" content={seo.keywords?.[lang] || ""} />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
      )}
      <Banner title={page?.title[lang]} />
      <div className="solutions-container">
        <div className="textJustifyCenter mt-5">
          <div className="solution-title f24 d-flex align-items-center justify-content-center mb-5">
            <span className='color10 fw500 f32'>{page?.showcases[0]?.title[lang]}</span>
          </div>
        </div>
        <Row>
          {
            (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
              .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
              .map((item, index) => {
                return (
                  <Col xs={12} sm={12} md={LineCount(page?.showcases[0]?.lineCount)} lg={LineCount(page?.showcases[0]?.lineCount)} xl={LineCount(page?.showcases[0]?.lineCount)} key={index} className="mb-3">
                    <div className="solution-item">
                      <div className="solution-image">
                        <img src={`${URL}${item?.files[0]}`} alt={item?.title[lang]} className="w-100" loading="lazy" />
                      </div>
                      <div className="solution-details d-flex align-items-center mt-3">
                        <div className='mt-2 mb-2'>
                          <img
                            src={`${URL}${item?.files[1]}`}
                            alt={item?.title[lang]}
                            style={{ width: '24px', height: '24px', marginLeft: "10px", }}
                            loading="lazy"
                          />
                          <span className='mb-0'>{item?.description[lang]}</span>
                        </div>
                      </div>
                      <div>
                        <h4 className='mb-0'>{item?.title[lang]}</h4>
                      </div>
                    </div>
                  </Col>
                )
              })
          }
        </Row>
      </div>
    </Celikler> : <div className="modern-spinner-wrapper">
      <div className="modern-spinner"></div>
    </div>
  );
};

export default Solution;
